import React, { useState, forwardRef } from 'react';
import { GripHorizontal, RefreshCw } from 'lucide-react';
import { Card } from '../ui/Card';
import { cn } from '../ui/Button';
interface WidgetWrapperProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
  onRemove?: () => void;
  onDoubleClickHandle?: () => void;
  readOnly?: boolean;
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  onMouseDown?: React.MouseEventHandler;
  onMouseUp?: React.MouseEventHandler;
  onTouchEnd?: React.TouchEventHandler;
}
export const WidgetWrapper = forwardRef<HTMLDivElement, WidgetWrapperProps>(({
  title,
  onRemove,
  onDoubleClickHandle,
  readOnly,
  children,
  className,
  style,
  onMouseDown,
  onMouseUp,
  onTouchEnd,
  ...props
}, ref) => {
  const [isRefreshing, setIsRefreshing] = useState(false);
  const handleRefresh = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsRefreshing(true);
    // Simulate refresh delay
    setTimeout(() => setIsRefreshing(false), 1000);
  };
  return <Card ref={ref} className={cn('jua-widget flex flex-col h-full bg-[#0B1120] border-slate-800 shadow-lg relative group overflow-hidden', className)} style={style} onMouseDown={onMouseDown} onMouseUp={onMouseUp} onTouchEnd={onTouchEnd} {...props} data-id="element-2288">
        {/* Drag handle strip — hidden in readOnly mode */}
        {!readOnly && <div className="jua-drag-handle draggable-handle flex items-center justify-center h-3.5 flex-shrink-0 cursor-move bg-[#0F172A] border-b border-white/[0.04] hover:bg-[#1a2744] transition-colors relative" onDoubleClick={e => {
      e.stopPropagation();
      onDoubleClickHandle?.();
    }} title="Double-click to expand to fill row" data-id="element-2289">
            <GripHorizontal size={10} className="text-white/20 group-hover:text-white/40 transition-colors" data-id="element-2290" />

            {/* Refresh Button */}
            <button onClick={handleRefresh} className="jua-widget-refresh absolute right-1 top-1/2 -translate-y-1/2 p-0.5 text-white/20 hover:text-white/60 hover:bg-white/10 rounded transition-all opacity-0 group-hover:opacity-100" title="Refresh widget data" data-id="element-2291">
              <RefreshCw size={10} className={cn(isRefreshing && 'animate-spin')} data-id="element-2292" />
            </button>
          </div>}
        <div className="flex-1 min-h-0 relative overflow-hidden" data-id="element-2293">
          {children}
        </div>
      </Card>;
});